/**
 * WhatsApp-style typing indicator
 * Shows "John is typing..." with animated dots
 * Matches mobile TypingIndicator.tsx
 */
import React from 'react';
import './TypingIndicator.css';

/**
 * Animated typing indicator with bouncing dots
 *
 * @param {Object} props
 * @param {Array<{userId: string, userName: string}>} props.typingUsers - List of users currently typing
 * @param {boolean} [props.isGroupChat=false] - Whether this is a group chat
 */
const TypingIndicator = ({ typingUsers = [], isGroupChat = false }) => {
  if (!typingUsers || typingUsers.length === 0) {
    return null;
  }

  // Format the typing text (matches mobile logic)
  const getTypingText = () => {
    if (typingUsers.length === 1) {
      return `${typingUsers[0].userName} is typing`;
    } else if (typingUsers.length === 2) {
      return `${typingUsers[0].userName} and ${typingUsers[1].userName} are typing`;
    } else {
      return `${typingUsers.length} people are typing`;
    }
  };

  return (
    <div className="typing-indicator-container">
      <div className="typing-indicator-content">
        <span className="typing-indicator-text">{getTypingText()}</span>
        <div className="typing-indicator-dots">
          <span className="typing-dot typing-dot-1"></span>
          <span className="typing-dot typing-dot-2"></span>
          <span className="typing-dot typing-dot-3"></span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
